import React, { createRef, useCallback, useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import { useIdleTimer } from 'react-idle-timer'
//import { GlobalDebug } from './utilities/remove-console'

import Login from './modules/dashboard/Login'
import Dashboard from './modules/dashboard/Dashboard'
import ProtectedRoute from './components/navigation/PrivateRoute'
import ReservationRoutes from './modules/reservations/routes'
import BookingRoutes from './modules/booking/routes'
import ReprintRoutes from './modules/reprints/routes'
import ReservationTripsRoutes from './modules/reservationTrips/routes'
import adminTiketsRoutes from './modules/adminTikets/routes'

//import { Loader } from './components/transpais'

// eslint-disable-next-line import/no-anonymous-default-export
//export default () => <PinpadProvider>
//  <App/>
//</PinpadProvider>
import './scss/Layout.scss'
import './scss/Animations.scss'
import {
  BASE_URL,
  IDLE_TIMEOUT_SECONDS,
  IDLE_PROMPT_SECONDS,
  SAVER_TIMEOUT_SECONDS,
  IDLE_DONE_TIMEOUT_SECONDS, IDLE_DONE_PROMPT_SECONDS, KIOSK_CONFIRMED_IDLE_DONE_EVENT,
  RELOAD_TOUCH_COUNT, DEBUG_TIMERS, DEBUG_PINPAD, ENABLE_FLIGHT_RECORDER,
} from './utilities/constants'
import { useAtom } from 'jotai'
import { idleDoneTimerPaused, idleTimerPaused, onAdmin, 
  bookingSessionDepartureBlockedTickets, 
  bookingSessionReturningBlockedTickets,
  bookingSessionTripConfig,
  bookingSessionReturningTripId,
  bookingSessionDepartureTripId,
  bookingSessionTrips,
  bookingSessionOrigin,
  bookingSessionDestination,
  bookingSessionPassengers,
  bookingSessionCart,
  bookingSessionDepartureTrip,
  claveUsuario,
  usuarioID,
  puntoVentaID,
  estacionID,
  accessToken,
  TranspaisIDToken,
  nombrePuntoVenta,
  originDefault,
} from './utilities/atoms'
import transpais from './services/transpais'
import { Countdown } from './components/transpais'
import { useModal } from './contexts/modal.context'
import TranspaisScreenSaver from './components/transpais/TranspaisScreenSaver'
import styles from './modules/reservations/ReservationLookup.module.scss'
import Keyboard from 'react-simple-keyboard'
import { useLogger } from './contexts/logger.context'
import { useModalView } from './contexts/modalview.context'
import { usePinpad } from './contexts/pinpad.context'
import { startPinpadFlow, logFlowStep, getPinpadFlowId } from './utilities/pinpad-v2/flow-logger'
import { showPortsToPermission } from './helpers/showPortsToPermission'
import { syncServiceTranspaisIdToken } from './helpers/pinHelper'
import { requestElectronQuit } from './helpers/requestElectronQuit'
import { ensureLocalBookingStubFromAccessToken, isLocalBookingApiEnabled } from './helpers/localBookingApi'
import { isValidTranspaisJwtShape } from './utilities/token'
import { FlightRecorderPanel } from './debug/FlightRecorderPanel'
import { recordFlightEvent, setFlightRecorderEnabled, isFlightRecorderEnabled } from './debug/flightRecorder'
import jwt_decode from 'jwt-decode'

const App = () => {

  const [bookingDepartureBlockedTickets, setBookingDepartureBlockedTickets] = useAtom(bookingSessionDepartureBlockedTickets)
  const [bookingReturningBlockedTickets, setBookingReturningBlockedTickets] = useAtom(bookingSessionReturningBlockedTickets)
  const [bookingTripConfig, setBookingTripConfig] = useAtom(bookingSessionTripConfig)
  const [bookingReturningTripId, setBookingReturningTripId] = useAtom(bookingSessionReturningTripId)
  const [bookingDepartureTripId, setBookingDepartureTripId] = useAtom(bookingSessionDepartureTripId)
  const [bookingSessionId] = useAtom(bookingSessionTrips)
  const [bookingOrigin] = useAtom(bookingSessionOrigin)
  const [bookingDestination] = useAtom(bookingSessionDestination)
  const [bookingPassengers] = useAtom(bookingSessionPassengers)
  const [bookingCart] = useAtom(bookingSessionCart)
  const [bookingDepartureTrip] = useAtom(bookingSessionDepartureTrip)
  const [, setOriginDefaultValue] = useAtom(originDefault)

  const adminPass = createRef()
  const idleDoneTimeOut = createRef(false)

  const [idleTimeDebug, setIdleTimeDebug] = useState(0)
  const [idleDoneTimeDebug, setIdleDoneTimeDebug] = useState(0)
  const [idleScreenDebug, setIdleScreenDebug] = useState(0)

  const [isOnAdmin, setIsOnAdmin] = useAtom(onAdmin)
  const [idlePaused, setIdlePaused] = useAtom(idleTimerPaused)
  const [idleDonePaused, setIdleDonePaused] = useAtom(idleDoneTimerPaused)

  const navigate = useNavigate()
  const location = useLocation()
  const {showModal, hideModal, setupModal} = useModal()
  const {destroyModalView} = useModalView()
  const {loggerDebug, loggerLog, loggerError} = useLogger()
  const { startWithCredentials } = usePinpad()

  const [showScreen, setShowScreen] = useState(false)
  const [showLogout, setShowLogout] = useState(false)
  const [flightOpen, setFlightOpen] = useState(false)
  const showScreenRef = React.useRef(false)
  const suppressSaverRef = React.useRef(false)
  const routeRef = React.useRef('')
  const prevRouteRef = React.useRef('')
  const atomPrevRef = React.useRef({})

  useEffect(() => {
    showScreenRef.current = !!showScreen
    routeRef.current = location.pathname
  }, [showScreen, location.pathname])

  // NAV:ROUTE for Flow Inspector
  useEffect(() => {
    if (!ENABLE_FLIGHT_RECORDER || !isFlightRecorderEnabled()) {
      prevRouteRef.current = location.pathname
      return
    }
    const from = prevRouteRef.current || null
    const to = location.pathname
    if (from !== to) {
      recordFlightEvent('NAV:ROUTE', { from, to, pathname: to }, 'App.location')
      prevRouteRef.current = to
    }
  }, [location.pathname])

  // Whitelist ATOM:BOOKING_* (session / trip / seats / cart) — no seatmaps
  useEffect(() => {
    if (!ENABLE_FLIGHT_RECORDER || !isFlightRecorderEnabled()) return
    const prev = atomPrevRef.current
    const next = {
      sessionId: bookingSessionId || '',
      departureTripId: bookingDepartureTripId || '',
      returningTripId: bookingReturningTripId || '',
      passengerCount: Array.isArray(bookingPassengers) ? bookingPassengers.length : 0,
      seatIds: Array.isArray(bookingPassengers)
        ? bookingPassengers.flatMap((p) => (p?.seats || []).map((s) => s?.seatId).filter(Boolean))
        : [],
      cartId: Array.isArray(bookingCart)
        ? (bookingCart[0]?.id || bookingCart[0]?.cartId || bookingCart.length)
        : (bookingCart?.id || bookingCart?.cartId || ''),
    }
    if (prev.sessionId !== next.sessionId && next.sessionId) {
      recordFlightEvent('ATOM:BOOKING_SESSION', { sessionId: next.sessionId }, 'App.atomWatch')
    }
    if (prev.departureTripId !== next.departureTripId && next.departureTripId) {
      recordFlightEvent('ATOM:BOOKING_TRIP', { leg: 'departure', tripId: next.departureTripId }, 'App.atomWatch')
    }
    if (prev.returningTripId !== next.returningTripId && next.returningTripId) {
      recordFlightEvent('ATOM:BOOKING_TRIP', { leg: 'return', tripId: next.returningTripId }, 'App.atomWatch')
    }
    const seatKey = next.seatIds.join(',')
    const prevSeatKey = (prev.seatIds || []).join(',')
    if (seatKey !== prevSeatKey) {
      recordFlightEvent('ATOM:BOOKING_SEATS', {
        passengerCount: next.passengerCount,
        seatIds: next.seatIds,
      }, 'App.atomWatch')
    }
    if (String(prev.cartId) !== String(next.cartId) && next.cartId) {
      recordFlightEvent('ATOM:BOOKING_CART', { cartId: next.cartId }, 'App.atomWatch')
    }
    atomPrevRef.current = next
  }, [
    bookingSessionId,
    bookingDepartureTripId,
    bookingReturningTripId,
    bookingPassengers,
    bookingCart,
  ])

  // Requiere REACT_APP_ENABLE_FLIGHT_RECORDER=1. Luego: `?fr=1`, localStorage o 3 taps arriba-derecha.
  useEffect(() => {
    if (!ENABLE_FLIGHT_RECORDER) return
    const params = new URLSearchParams(window.location.search || '')
    const fromUrl = params.get('fr') === '1'
    const fromStorage = (() => {
      try { return window.localStorage.getItem('__flight_recorder') === '1' } catch { return false }
    })()
    const enabled = fromUrl || fromStorage
    setFlightRecorderEnabled(enabled)
    setFlightOpen(enabled)
    if (enabled) {
      recordFlightEvent('RECORDER:ENABLED', { fromUrl, fromStorage }, 'App.initFlightRecorder')
    }
  }, [])

  useEffect(() => {
    if (!ENABLE_FLIGHT_RECORDER) return
    const cornerPx = 90
    const required = 3
    const windowMs = 2000
    let taps = 0
    let firstAt = 0

    const onTap = (e) => {
      const t = e.touches && e.touches[0] ? e.touches[0] : e
      const x = t?.clientX
      const y = t?.clientY
      if (!Number.isFinite(x) || !Number.isFinite(y)) return
      const minX = window.innerWidth - cornerPx
      if (x < minX || y > cornerPx) return

      const now = Date.now()
      if (!firstAt || now - firstAt > windowMs) {
        firstAt = now
        taps = 0
      }
      taps += 1

      if (taps >= required) {
        taps = 0
        firstAt = 0
        const next = !isFlightRecorderEnabled()
        setFlightRecorderEnabled(next)
        setFlightOpen(next)
        try { window.localStorage.setItem('__flight_recorder', next ? '1' : '0') } catch {}
        recordFlightEvent('RECORDER:TOGGLE', { enabled: next, via: 'corner_taps' }, 'App.secretGesture')
      }
    }

    // touch-only kiosk: escuchar touchstart + pointerdown por compat.
    window.addEventListener('touchstart', onTap, { passive: true, capture: true })
    window.addEventListener('pointerdown', onTap, { passive: true, capture: true })
    return () => {
      window.removeEventListener('touchstart', onTap, { capture: true })
      window.removeEventListener('pointerdown', onTap, { capture: true })
    }
  }, [])

  // USER input inspector (touch-only): detecta taps "ignorados" cuando el saver está visible.
  useEffect(() => {
    if (!isFlightRecorderEnabled()) return

    const onInput = (e) => {
      const type = e?.type || null
      const target = e?.target
      const tag = target?.tagName ? String(target.tagName).toLowerCase() : null
      const id = target?.id ? String(target.id) : null
      const cls = target?.className ? String(target.className).slice(0, 160) : null
      recordFlightEvent('USER:INPUT', {
        type,
        showScreen: showScreenRef.current,
        route: routeRef.current,
        target: { tag, id, class: cls },
      }, 'App.userInput')

      if (showScreenRef.current) {
        const startedAt = Date.now()
        setTimeout(() => {
          // si después de ~500ms sigue visible, este input fue "ignorado" (o no pudo cerrar saver).
          if (showScreenRef.current && Date.now() - startedAt >= 450) {
            recordFlightEvent('USER:INPUT_IGNORED', { type, route: routeRef.current }, 'App.userInput.heuristic')
          }
        }, 500)
      }
    }

    const opts = { capture: true, passive: true }
    window.addEventListener('pointerdown', onInput, opts)
    window.addEventListener('touchstart', onInput, opts)
    window.addEventListener('keydown', onInput, opts)
    return () => {
      window.removeEventListener('pointerdown', onInput, opts)
      window.removeEventListener('touchstart', onInput, opts)
      window.removeEventListener('keydown', onInput, opts)
    }
  }, [])

  //For logout set variables on null
  const [cveUsuario, setCveUsuario] = useAtom(claveUsuario)
  const [usuarioId, setUsuarioId] = useAtom(usuarioID)
  const [puntoVentaId, setPuntoVentaId] = useAtom(puntoVentaID)
  const [estacionId, setEstacionId] = useAtom(estacionID)
  const [token, setToken] = useAtom(accessToken)
  const [transpaisIDToken, setTranspaisIDToken] = useAtom(TranspaisIDToken)
  const [nombPuntoVenta, setNombPuntoVenta] = useAtom(nombrePuntoVenta)

  /**
   * @REMOVE_CONSOLES
   * // remove the working of console logs
   * // remove any accidental use of console logs
   */
  useEffect(() => {
    loggerDebug(process.env.REACT_APP_ENVIRONMENT)

    //if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    //  GlobalDebug(false, true)
    //}
  }, [])

  useEffect(() => {
    const raw = typeof transpaisIDToken === 'string' ? transpaisIDToken.trim() : ''
    if (raw !== '' && !isValidTranspaisJwtShape(raw)) {
      loggerDebug('TranspaisIDToken inválido en storage; se limpia')
      setTranspaisIDToken('')
      syncServiceTranspaisIdToken('')
      return
    }
    syncServiceTranspaisIdToken(transpaisIDToken || '')

    if (raw !== '' && isLocalBookingApiEnabled()) {
      ensureLocalBookingStubFromAccessToken(raw, jwt_decode).catch((error) => {
        loggerDebug('No se pudo remintar stub JWT local de booking', error)
      })
    }
  }, [transpaisIDToken, setTranspaisIDToken])

  const openIdlePromptModal = (sourceTimer, promptFallbackSeconds, flightPrefix) => {
    if (location.pathname === '/' || location.pathname === '/login') return

    idleDoneTimeOut.current = true
    recordFlightEvent(`${flightPrefix}:PROMPT_OPEN`, { route: location.pathname }, 'App.openIdlePromptModal')

    const rawRemaining = sourceTimer.getRemainingTime()
    const fallbackMs = 1000 * promptFallbackSeconds
    const safeRemaining = Number.isFinite(rawRemaining)
      ? Math.max(0, Math.floor(rawRemaining))
      : fallbackMs
    const deadline = Date.now() + (safeRemaining > 0 ? safeRemaining : fallbackMs)

    setupModal({
      title: '¿Aún estás ahí?',
      content: <p>Si no, cerraremos esta sesión en: <Countdown
        date={ deadline }
        type={ 'simple' } format={ 'm:s' }/></p>,
      actions: {
        positive: {
          title: 'Aquí sigo',
          onClick: () => {
            idleDoneTimeOut.current = false
            recordFlightEvent(`${flightPrefix}:PROMPT_CONFIRM`, { route: location.pathname }, 'App.openIdlePromptModal.positive')
            keepActive()
            hideModal()
          }
        }
      }
    })
    showModal()
  }

  // Timer global (5 min): no debe actuar en Confirmed mientras corre el timer "done" (10 min).
  const onGlobalPrompt = () => {
    if (!idleDonePaused) {
      recordFlightEvent('IDLE:PROMPT_SKIPPED', { reason: 'done_mode', route: location.pathname }, 'App.onGlobalPrompt')
      idleTimer.pause()
      return
    }
    loggerLog('prompting the user (global idle)')
    openIdlePromptModal(idleTimer, IDLE_PROMPT_SECONDS, 'IDLE')
  }

  const onGlobalIdle = () => {
    if (!idleDonePaused) {
      recordFlightEvent('IDLE:ON_IDLE_SKIPPED', { reason: 'done_mode', route: location.pathname }, 'App.onGlobalIdle')
      idleTimer.pause()
      return
    }
    recordFlightEvent('IDLE:ON_IDLE', { route: location.pathname }, 'App.onGlobalIdle')
    forceReset()
  }

  const onDonePrompt = () => {
    if (idleDonePaused) return
    loggerLog('prompting the user (done idle)')
    openIdlePromptModal(idleDoneTimer, IDLE_DONE_PROMPT_SECONDS, 'IDLE:DONE')
  }

  const onDoneIdle = () => {
    if (idleDonePaused) return
    const path = routeRef.current || location.pathname
    recordFlightEvent('IDLE:DONE_ON_IDLE', { route: path }, 'App.onDoneIdle')
    idleDoneTimeOut.current = false
    hideModal()
    destroyModalView()
    suppressSaverRef.current = true
    setShowScreen(false)
    screenSaverTimer.pause()
    if (path.includes('/confirmed')) {
      window.dispatchEvent(new CustomEvent(KIOSK_CONFIRMED_IDLE_DONE_EVENT))
      setTimeout(() => {
        suppressSaverRef.current = false
      }, 500)
      return
    }
    forceReset()
  }

  const onActive = (event) => {
    // Close Modal Prompt
    // Do some active action
    //loggerLog('user is active', event)
    //setShowIdleModal(false)
    //hideModal()
  }

  const onAction = (event) => {
    if (!idleTimer.isPrompted() && !idleDoneTimer.isPrompted()) {
      recordFlightEvent('USER:IDLE_ACTION', { type: event?.type || null }, 'App.onAction')
      keepActive()
    }
  }

  const idleTimer = useIdleTimer({
    timeout: 1000 * IDLE_TIMEOUT_SECONDS,
    promptTimeout: 1000 * IDLE_PROMPT_SECONDS,
    onPrompt: onGlobalPrompt,
    onIdle: onGlobalIdle,
    onActive,
    onAction,
    debounce: 250,
    startManually: true,
    name: 'activity-timer'
  })

  const idleDoneTimer = useIdleTimer({
    timeout: 1000 * IDLE_DONE_TIMEOUT_SECONDS,
    promptTimeout: 1000 * IDLE_DONE_PROMPT_SECONDS,
    onPrompt: onDonePrompt,
    onIdle: onDoneIdle,
    onActive,
    onAction,
    debounce: 250,
    startManually: true,
    name: 'done-timer'
  })

  const onScreenIdle = () => {
    loggerDebug('showScreenSaver')
    if (suppressSaverRef.current) {
      recordFlightEvent('SAVER:SHOW_SKIPPED', { reason: 'force_reset' }, 'App.onScreenIdle')
      return
    }
    const path = routeRef.current || location.pathname
    if (path === '/login') {
      recordFlightEvent('SAVER:SHOW_SKIPPED', { route: path, reason: 'home_route' }, 'App.onScreenIdle')
      return
    }
    if (showScreenRef.current) {
      recordFlightEvent('SAVER:SHOW_SKIPPED', {
        route: location.pathname,
        reason: 'already_visible',
        idlePaused,
        idleDonePaused,
      }, 'App.onScreenIdle')
      return
    }
    hideModal()
    destroyModalView()
    recordFlightEvent('SAVER:SHOW', {
      route: location.pathname,
      modalDestroyed: true,
      idlePaused,
      idleDonePaused,
    }, 'App.onScreenIdle')
    setShowScreen(true)
  }

  const onScreenActive = (event) => {
    // No cerrar el overlay aquí: react-idle-timer dispara onActive al salir de idle y provocaba
    // ciclo show/hide cada 60s. El cierre es solo por interacción (overlay / keepActive).
    recordFlightEvent('SAVER:TIMER_ACTIVE', { type: event?.type || null }, 'App.onScreenActive')
  }

  const onScreenAction = (event) => {
    //loggerLog('user did something', event)
  }

  const screenSaverTimer = useIdleTimer({
    timeout: 1000 * SAVER_TIMEOUT_SECONDS,
    //promptTimeout: 1000 * IDLE_PROMPT_SECONDS,
    //onPrompt,
    onIdle: onScreenIdle,
    onActive: onScreenActive,
    onAction: onScreenAction,
    debounce: 250,
    startManually: true,
    name: 'screen-saver-timer'
  })

  const keepActive = () => {
    const saverVisible = showScreenRef.current
    recordFlightEvent('IDLE:KEEP_ACTIVE', { idlePaused, idleDonePaused, showScreen: saverVisible }, 'App.keepActive')
    if (saverVisible) {
      setShowScreen(false)
      screenSaverTimer.start()
      if (!idlePaused && idleDonePaused) {
        idleTimer.activate()
      }
    } else if (!idlePaused) {
      // activate() extiende la cuenta sin reiniciar a 60s en cada mousemove/tecla.
      screenSaverTimer.activate()
    }
    if (!idlePaused && idleDonePaused) {
      idleTimer.activate()
    }
    if ((!idleDonePaused && idlePaused) && idleDoneTimeOut.current === false) {
      loggerDebug('reset done')
      idleDoneTimer.activate()
    }
  }

  const keepActiveRef = React.useRef(keepActive)
  keepActiveRef.current = keepActive

  const dismissScreenSaver = useCallback(() => {
    loggerDebug('dismissScreenSaver')
    recordFlightEvent('SAVER:DISMISS', { route: location.pathname }, 'App.dismissScreenSaver')
    setShowScreen(false)
    screenSaverTimer.start()
    keepActiveRef.current()
  }, [location.pathname])

  useEffect(() => {
    if (idlePaused === true) {
      loggerDebug('pause timer')
      recordFlightEvent('ATOM_SET:idlePaused', { value: true, showScreen, idleDonePaused }, 'App.effect.idlePaused')
      idleTimer.pause()
      // Modo "done" (idleDonePaused=false): solo pausa idle; el screensaver sigue su cuenta de 60s.
      if (idleDonePaused && !showScreen) {
        screenSaverTimer.pause()
      } else if (!showScreen) {
        screenSaverTimer.start()
      } else {
        screenSaverTimer.pause()
      }
    } else {
      loggerDebug('start timer')
      recordFlightEvent('ATOM_SET:idlePaused', { value: false, showScreen }, 'App.effect.idlePaused')
      if (idleDonePaused) {
        idleTimer.start()
      } else {
        idleTimer.pause()
      }
      if (!showScreen) {
        // En modo "done" (idleDonePaused=false) idlePaused debería ser true; no reiniciar screen a 60.
        if (idleDonePaused) {
          screenSaverTimer.start()
        }
      } else {
        screenSaverTimer.pause()
      }
    }
  }, [idlePaused, showScreen, idleDonePaused])

  /* Overlay visible: congelar cuenta del screensaver (solo decorativo). */
  useEffect(() => {
    if (showScreen) {
      recordFlightEvent('SAVER:OVERLAY_VISIBLE', { route: location.pathname }, 'App.effect.showScreen')
      screenSaverTimer.pause()
    } else {
      screenSaverTimer.start()
    }
  }, [showScreen])

  useEffect(() => {
    // En modo "done" el idle global debe seguir pausado al cerrar el screensaver.
    if (!showScreen && idleDonePaused) {
      idleTimer.activate()
    }
  }, [showScreen, idleDonePaused])

  useEffect(() => {
    if (!showScreen) return
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        dismissScreenSaver()
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [showScreen])

  // Corrige setIdlePaused(false) espurio (p. ej. cleanup de Review) mientras corre el timer "done".
  useEffect(() => {
    if (!idleDonePaused && !idlePaused) {
      recordFlightEvent('IDLE:DONE_MODE_RESYNC', { route: location.pathname }, 'App.effect.doneModeResync')
      setIdlePaused(true)
    }
  }, [idleDonePaused, idlePaused, location.pathname, setIdlePaused])

  useEffect(() => {
    if (idleDonePaused === false) {
      setIdlePaused(true)
      recordFlightEvent('ATOM_SET:idleDonePaused', { value: false }, 'App.effect.idleDonePaused')
      loggerDebug('pause timer y start done')
      idleTimer.pause()
      idleDoneTimer.start()
      if (!showScreen) {
        screenSaverTimer.start()
      }
    } else {
      recordFlightEvent('ATOM_SET:idleDonePaused', { value: true }, 'App.effect.idleDonePaused')
      loggerDebug('start timer and done')
      idleDoneTimer.pause()
      const leavingConfirmed = (routeRef.current || location.pathname).includes('/confirmed')
      if (leavingConfirmed) {
        idleTimer.pause()
      } else {
        setIdlePaused(false)
      }
    }
  }, [idleDonePaused, location.pathname])

  const logout = () => {
    setTranspaisIDToken('')
    setCveUsuario('')
    setUsuarioId(0)
    setPuntoVentaId(0)
    setEstacionId(0)
    setToken('')
    setNombPuntoVenta('')
    setOriginDefaultValue('')
    window.location = 'kioskexit1337'
  }

  const tickets = () => {
    navigate(`${ BASE_URL }/adminTikets/tickets`)
  }

  const unblockTickets = (_tripId, _bookingTicket) => {
    transpais.unblock(
      _tripId, _bookingTicket.map((ticket) => ticket.id)
    ).then((response) => {
        setBookingDepartureBlockedTickets([])
        setBookingReturningBlockedTickets([])
    }).catch((error) => {
        setBookingDepartureBlockedTickets([])
        setBookingReturningBlockedTickets([])
    })
  }

  const forceReset = () => {
    recordFlightEvent('IDLE:FORCE_RESET', { route: location.pathname }, 'App.forceReset')
    suppressSaverRef.current = true
    setShowScreen(false)
    screenSaverTimer.pause()
    if (bookingDepartureBlockedTickets.length > 0) {
      let _bookingTicket = bookingDepartureBlockedTickets
      unblockTickets(bookingDepartureTripId,_bookingTicket)
      if (bookingReturningBlockedTickets.length > 0) {
        _bookingTicket = bookingReturningBlockedTickets
        unblockTickets(bookingReturningTripId,_bookingTicket)
      }
    }
    hideModal()
    destroyModalView()
    setIdleDonePaused(true)
    idleDoneTimer.pause()
    idleTimer.activate()
    loggerDebug(location.pathname)
    if (location.pathname !== '/' && location.pathname !== '/login') {
      loggerDebug('forced')
      navigate(`${ BASE_URL }/`)
    }
    setTimeout(() => {
      suppressSaverRef.current = false
    }, 500)
  }

  document.addEventListener('contextmenu', event => event.preventDefault())

  useEffect(() => {
    if (!DEBUG_TIMERS) return

    const debug = setInterval(() => {
      setIdleTimeDebug(Math.round(idleTimer.getRemainingTime() / 1000))
      setIdleDoneTimeDebug(Math.round(idleDoneTimer.getRemainingTime() / 1000))
      setIdleScreenDebug(Math.round(screenSaverTimer.getRemainingTime() / 1000))
    }, 1000)

    return () => {
      clearInterval(debug)
    }
  }, [])

  //const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)
  const configurePinpad = async () => {
    const flowId = startPinpadFlow({ trigger: 'admin-setup' })
    const startTime = Date.now()

    logFlowStep({
      phase: 'INIT',
      step: 'Admin clicked Configurar PinPad button',
      stepNumber: 1,
      status: 'START',
      data: {
        flowId,
      },
    })

    try {
      const serialStartTime = Date.now()
      logFlowStep({
        phase: 'SERIAL',
        step: 'Requesting serial port permission',
        stepNumber: 2,
        status: 'START',
      })

      const serialInfo = await showPortsToPermission()

      logFlowStep({
        phase: 'SERIAL',
        step: 'Serial port selected',
        stepNumber: 3,
        status: 'SUCCESS',
        duration: Date.now() - serialStartTime,
        data: serialInfo || {},
      })

      logFlowStep({
        phase: 'CONTEXT',
        step: 'Calling startWithCredentials',
        stepNumber: 4,
        status: 'START',
      })

      await startWithCredentials({
        name: '0005SIUA38',
        value: '5LV7H6BY0',
      })

      logFlowStep({
        phase: 'CONTEXT',
        step: 'startWithCredentials completed',
        stepNumber: 5,
        status: 'SUCCESS',
        duration: Date.now() - startTime,
      })

      setupModal({
        title: '✅ PinPad Configurado',
        content: (
          <>
            <p>El PinPad se ha configurado correctamente.</p>
            <p>El puerto serial ha sido seleccionado y el dispositivo está listo para procesar transacciones.</p>
          </>
        ),
        actions: {
          positive: {
            title: 'Cerrar',
            onClick: () => {
              setIsOnAdmin(false)
              hideModal()
            },
          },
        },
      })
      showModal()
    } catch (error) {
      logFlowStep({
        phase: 'ERROR',
        step: 'PinPad configuration failed',
        stepNumber: 6,
        status: 'ERROR',
        error: {
          code: error?.code || 'UNKNOWN',
          message: error?.message,
          stack: error?.stack,
          flowId: getPinpadFlowId(),
        },
      })
      loggerError('Error al configurar PinPad', error)

      setupModal({
        title: '❌ Error en Configuración',
        content: (
          <>
            <p><strong>Código:</strong> {error?.code || 'UNKNOWN'}</p>
            <p><strong>Mensaje:</strong> {error?.message || 'Error desconocido al configurar el PinPad'}</p>
          </>
        ),
        actions: {
          positive: {
            title: 'Cerrar',
            onClick: () => {
              setIsOnAdmin(false)
              hideModal()
            },
          },
        },
      })
      showModal()
    }
  }

  const closeBrowser = () => {
    setIsOnAdmin(true)
    setupModal({
      title: 'Transpais',
      content: <>
        <p>Introduce la contraseña de administrador.
          <br/>
          <input className={ 'passInput' } type={ 'password' }
                 ref={ adminPass }/>
          <div
            className={ [styles.keyboardWrapper].join(' ') }>
            <Keyboard
              onChange={ (input) => {
                loggerDebug('Input changed', input)
              } }
              onKeyPress={ (button) => {
                loggerDebug('Button pressed', button)
                if (button === '{esc}') {
                  //setShowScreenKeyboard(false)
                } else if (button === '{bksp}') {
                  //setBarcodeInputValue(barcodeInputValue.slice(0, -1))
                  adminPass.current.value = adminPass.current.value.slice(0, -1)
                } else {
                  //setCodeKey(button)
                  adminPass.current.value += button
                }
              } }
              layout={ {
                default: [
                  '1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}',
                ]
              } }
              display={ {
                '{bksp}': `<svg class="key-icon"><use xlink:Href="#delete-left"/></svg>`,
                '{esc}': `<svg class="key-icon"><use xlink:Href="#keyboard-down"/></svg>`,
              } }
            />
          </div>
        </p>
      </>,
      actions: {
        positive: {
          title: 'Continuar',
          onClick: () => {
            loggerDebug(adminPass.current.value)
            if (adminPass.current.value === process.env.REACT_APP_ADMIN_PASS) {
              setShowLogout(true)
            } else {
              setIsOnAdmin(false)
              hideModal()
            }
          }
        },
        negative: {
          title: 'Cancelar',
          onClick: () => {
            setIsOnAdmin(false)
            hideModal()
          }
        },
      }
    })
    showModal()
  }

  const close = () => {
    setupModal({
      title: 'Transpais',
      content: <>
        <p>Selecciona la opción deseada.
          <br/>
        </p>
      </>,
      cancelable: true,
      actions: {
        extra: {
          title: 'Cerrar kiosco',
          onClick: () => {
            loggerDebug('Saliendo del kiosco')
            hideModal()
            requestElectronQuit()
          }
        },
        positiveExtra: {
          title: 'Tickets',
          onClick: () => {
            tickets()
            hideModal()
          }
        },
        // extraTwo: {
        //   title: 'Configurar PinPad',
        //   onClick: async () => {
        //     setIsOnAdmin(false)
        //     hideModal()
        //     await configurePinpad()
        //   }
        // },
      }
    })
    showModal()
    setShowLogout(false)
  }

  useEffect(() => {
    if(showLogout) {
      close()
    }
  },[showLogout])

  return (
    <>
      {DEBUG_TIMERS && <div className={'timersDebug'}>
        <p>idle: {idleTimeDebug}</p>
        <p>done: {idleDoneTimeDebug}</p>
        <p>screen: {idleScreenDebug}</p>
        <p>pinpad: {DEBUG_PINPAD ? 'Si' : 'No'}</p>
      </div>}
      <div className={ 'clicker' } onClick={ (e) => {
        if (e.detail === RELOAD_TOUCH_COUNT) {
          closeBrowser()
        }
      } }></div>
      <TranspaisScreenSaver show={ showScreen } onInteract={ dismissScreenSaver }/>
      {ENABLE_FLIGHT_RECORDER && (
        <FlightRecorderPanel
          open={ flightOpen }
          onClose={ () => setFlightOpen(false) }
          contextState={ {
            route: location.pathname,
            showScreen,
            idlePaused,
            idleDonePaused,
            sessionId: bookingSessionId || null,
            origin: bookingOrigin?.shortCode || bookingOrigin?.code || bookingOrigin?.name || null,
            destination: bookingDestination?.shortCode || bookingDestination?.code || bookingDestination?.name || null,
            seatId: Array.isArray(bookingPassengers)
              ? bookingPassengers.flatMap((p) => (p?.seats || []).map((s) => s?.seatId)).filter(Boolean).slice(-1)[0] || null
              : null,
            seatLabel: Array.isArray(bookingPassengers)
              ? bookingPassengers.flatMap((p) => (p?.seats || []).map((s) => s?.label || s?.rowLabel)).filter(Boolean).slice(-1)[0] || null
              : null,
            fareId: Array.isArray(bookingPassengers)
              ? bookingPassengers.map((p) => p?.fareId).filter(Boolean).slice(-1)[0] || null
              : null,
            cartId: Array.isArray(bookingCart)
              ? (bookingCart[0]?.id || bookingCart[0]?.cartId || null)
              : (bookingCart?.id || bookingCart?.cartId || null),
            passengerCount: Array.isArray(bookingPassengers) ? bookingPassengers.length : 0,
            tripId: bookingDepartureTripId || bookingDepartureTrip?.id || null,
          } }
        />
      )}
      <Routes>
        <Route exact path="/login" element={ <Login/> }/>
        <Route exact path="/" element={ <ProtectedRoute component={ <Dashboard/> }/> }/>
        { ReservationRoutes }
        { BookingRoutes }
        { ReprintRoutes }
        { ReservationTripsRoutes}
        { adminTiketsRoutes }
      </Routes>
    </>
  )
}

export default Sentry.withProfiler(App)
